module.exports = __webpack_public_path__ + "img/comrades.c6e4dd92.png";